<template>
    <div class="change-priority-config">
        <div class="config-field">
            <label>{{ $t("taskModuleRules.newPriority") }}</label>
            <a-select
                v-model="localConfig.priority"
                :placeholder="$t('taskModuleRules.selectPriority')"
                style="width: 100%;"
                @change="emitChange"
            >
                <a-select-option value="lowest">{{ $t("taskModuleRules.lowest") }}</a-select-option>
                <a-select-option value="low">{{ $t("taskModuleRules.low") }}</a-select-option>
                <a-select-option value="medium">{{ $t("taskModuleRules.medium") }}</a-select-option>
                <a-select-option value="high">{{ $t("taskModuleRules.high") }}</a-select-option>
                <a-select-option value="highest">{{ $t("taskModuleRules.highest") }}</a-select-option>
            </a-select>
        </div>
    </div>
</template>

<script>
export default {
    name: "ChangePriorityConfig",
    props: {
        value: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            localConfig: { priority: 'medium' }
        };
    },
    watch: {
        value: {
            handler(newVal) {
                if (newVal) {
                    this.localConfig = JSON.parse(JSON.stringify(newVal));
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        emitChange() {
            this.$emit("input", JSON.parse(JSON.stringify(this.localConfig)));
        }
    }
};
</script>

<style lang="scss" scoped>
.change-priority-config {
    .config-field {
        label {
            display: block;
            font-weight: 600;
            margin-bottom: 8px;
            color: #1a1a1a;
        }
    }
}
</style>
